import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-624f9b66"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "text-center mt2" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "bold f3 color-primary" }, "Forestry Disposal PRICE LIST"),
  /*#__PURE__*/_createElementVNode("div", { class: "bold f1-5 color-black" }, "579 Fitchburg State Rd Ashby MA")
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "text-center my2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "bold f2 color-primary mb1" }, "75 Yard Log Truck Loads PICKUP:"),
  /*#__PURE__*/_createElementVNode("div", { class: "bold f1-5 color-black" }, [
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("span", { class: "color-primary" }, "LOGS/BRUSH"),
      /*#__PURE__*/_createElementVNode("span", { class: "mlh color-black" }, "$600")
    ]),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("span", { class: "color-primary" }, "STUMPS"),
      /*#__PURE__*/_createElementVNode("span", { class: "mlh color-black" }, "$1000")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "bold f1-5 color-black" }, [
    /*#__PURE__*/_createTextVNode("Anywhere within 90 minute drive of "),
    /*#__PURE__*/_createElementVNode("b", null, "ASHBY YARD")
  ])
], -1))
const _hoisted_3 = { class: "text-center my2" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "text-center my2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "f4 color-primary mb1" }, [
    /*#__PURE__*/_createTextVNode("TEXT ERIC: "),
    /*#__PURE__*/_createElementVNode("span", { class: "f4 color-primary mb1" }, "774-279-1922")
  ])
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "text-center my2" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "truck.png",
    alt: "Arbor Works Truck",
    class: "flyer-truck"
  })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "dropoff-flex" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dropoff-list-col" }, [
    /*#__PURE__*/_createElementVNode("ul", { class: "flyer-dropoff-list" }, [
      /*#__PURE__*/_createElementVNode("li", { class: "bold f1-5 color-primary" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "dot orange" }),
        /*#__PURE__*/_createTextVNode(" DROP OFF-CLEAN Chips- "),
        /*#__PURE__*/_createElementVNode("span", { class: "mlh" }, "FREE!")
      ]),
      /*#__PURE__*/_createElementVNode("li", { class: "bold f1-5 color-primary" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "dot orange" }),
        /*#__PURE__*/_createTextVNode(" DROP OFF-CLEAN Fill- "),
        /*#__PURE__*/_createElementVNode("span", { class: "mlh" }, "FREE!")
      ]),
      /*#__PURE__*/_createElementVNode("li", { class: "bold f1-5 color-black" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "dot" }),
        /*#__PURE__*/_createTextVNode(" DROP OFF- "),
        /*#__PURE__*/_createElementVNode("span", null, "PINE and HARDWOOD-"),
        /*#__PURE__*/_createTextVNode(),
        /*#__PURE__*/_createElementVNode("span", { class: "mlh" }, "$100/Log Truck Load")
      ]),
      /*#__PURE__*/_createElementVNode("li", { class: "bold f1-5 color-black" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "dot" }),
        /*#__PURE__*/_createTextVNode(" DROP OFF- "),
        /*#__PURE__*/_createElementVNode("span", null, "CLEAN BRUSH-"),
        /*#__PURE__*/_createTextVNode(),
        /*#__PURE__*/_createElementVNode("span", { class: "mlh" }, "$200/log truck load")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "f1 color-black" }, [
      /*#__PURE__*/_createElementVNode("span", null, "*Ask for dump trailer pricing."),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createElementVNode("span", null, "*Stump drop off not accepted.")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "dropoff-image-col" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "logs.png",
      alt: "Logs Photo",
      class: "logs-photo"
    })
  ])
], -1))

import TheHeader from '../components/TheHeader.vue';
import TheFooter from '../components/TheFooter.vue';
import BaseContainer from '../components/BaseContainer.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TheHeader),
    _createVNode(BaseContainer, { class: "container" }, {
      default: _withCtx(() => [
        _hoisted_1,
        _hoisted_2,
        _createElementVNode("section", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: "/order",
            class: "schedule-button"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" SCHEDULE A PICKUP ")
            ]),
            _: 1
          })
        ]),
        _hoisted_4,
        _hoisted_5,
        _hoisted_6
      ]),
      _: 1
    }),
    _createVNode(TheFooter)
  ], 64))
}
}

})